import React from "react";
import { Link } from "react-router-dom";

const FormAddMyTicket = ({ setShow, size }) => {
  return (
    <div className="panel is-link">
        <p className="panel-heading">ADD TICKET</p>
        <div className="panel-tabs p-2">
            <div className="is-inline-flex">
              <Link to="/mytickets" className="button has-text-weight-semibold is-small is-info is-outlined mr-2">
                <span className="is-size-6">Cancel</span>                
              </Link>
              
              <button className="button has-text-weight-semibold is-small is-info is-outlined mr-2" onClick={() => setShow(true)}>
                <span className="is-size-6">Show Product List</span>
              </button>
              <button className="button has-text-weight-semibold is-small is-info is-outlined" onClick={() => setShow(false)}>
                <span className="is-size-6">Show Form Ticket<span className="ml-1 has-text-weight-bold">({size})</span></span>
              </button>              
            </div>           
        </div>
    </div>
  );
};

export default FormAddMyTicket;